module.exports = __webpack_public_path__ + "img/anjun-logo.c6fff09e.png";